(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Soļu kartītes parādās pa vienai, nevis visas reizē
  document.querySelectorAll('.es-steps .step').forEach(function (el, i) {
    el.style.transitionDelay = (i % 3) * 70 + 'ms';
  });

  // Ceļa līnija zīmējas, kad bloks parādās ekrānā
  var tls = document.querySelectorAll('.es-timeline');
  if (tls.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      tls.forEach(function (t) {
        t.classList.add('play');
        var f = t.querySelector('.es-line-fill');
        if (f) { if (window.innerWidth > 880) { f.style.width = '100%'; } else { f.style.height = '100%'; } }
      });
    } else {
      var tio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('play');
          // Platumu uzliekam tieši uz elementa – tā tas nav atkarīgs no CSS kārtulu cīņas
          var fill = e.target.querySelector('.es-line-fill');
          if (fill) { if (window.innerWidth > 880) { fill.style.width = '100%'; } else { fill.style.height = '100%'; } }
          tio.unobserve(e.target);
        });
      }, { threshold: 0.25 });
      tls.forEach(function (t) { tio.observe(t); });
      setTimeout(function () {
        tls.forEach(function (t) {
          t.classList.add('play');
          var f = t.querySelector('.es-line-fill');
          if (f) { if (window.innerWidth > 880) { f.style.width = '100%'; } else { f.style.height = '100%'; } }
        });
      }, 3000);
    }
  }
  // tl-play

  var nums = document.querySelectorAll('.es-stats[data-count] .stat b');
  if (!nums.length || reduce || !('IntersectionObserver' in window)) return;

  // Uzskaitām tikai īstus skaitļus no 10 – mazākus skaitīt nav jēgas,
  // un tekstu bez cipariem (piem. "Bez maksas") neaiztiekam vispār.
  function prepare(el) {
    var text = el.textContent;
    var m = text.match(/\d+(?:[.,]\d+)?/);
    if (!m) return null;
    var token = m[0];
    var value = parseFloat(token.replace(/[  ]/g, '').replace(',', '.'));
    if (!isFinite(value) || value < 10) return null;
    var decimals = (token.match(/[.,](\d+)$/) || [null, ''])[1].length;
    var sep = token.indexOf(',') > -1 ? ',' : '.';
    return { text: text, token: token, value: value, decimals: decimals, sep: sep, index: m.index };
  }

  var items = [];
  nums.forEach(function (el) {
    var p = prepare(el);
    if (p) { items.push({ el: el, p: p }); }
  });
  if (!items.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      var item = items.filter(function (x) { return x.el === e.target; })[0];
      if (!item) return;
      var p = item.p, start = null, dur = 850;
      function frame(t) {
        if (!start) start = t;
        var prog = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - prog, 3);
        var shown = (p.value * eased).toFixed(p.decimals).replace('.', p.sep);
        item.el.textContent = p.text.slice(0, p.index) + shown + p.text.slice(p.index + p.token.length);
        if (prog < 1) requestAnimationFrame(frame);
        else item.el.textContent = p.text;
      }
      requestAnimationFrame(frame);
    });
  }, { threshold: 0.6 });

  items.forEach(function (x) { io.observe(x.el); });
})();
